import { useState } from "react";
import { useGetCustomersQuery } from "@/services/api/user/customerApi";

/**
 * Custom hook for managing customer data
 * Provides pagination and search functionality for customers
 */
export const useCustomerData = () => {
  // ==========================================
  // Pagination State
  // ==========================================
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
  });

  // ==========================================
  // Filter State
  // ==========================================

  // ==========================================
  // Search State
  // ==========================================
  const [search, setSearch] = useState("");

  // ==========================================
  // Pagination Handlers
  // ==========================================
  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handlePageSizeChange = (per_page) => {
    setPagination({ page: 1, per_page });
  };

  // ==========================================
  // Search Handler
  // ==========================================
  const handleSearch = (searchTerm) => {
    const trimmedSearch = searchTerm.trim();
    setSearch(trimmedSearch);
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  const {
    data: apiResponse = {},
    isLoading,
    isFetching,
    error,
    refetch,
  } = useGetCustomersQuery({
    page: pagination.page,
    per_page: pagination.per_page,
    search: search,
  });

  // Extract data from nested response structure
  const responseData = apiResponse?.data?.original || apiResponse;
  const customersData = responseData.data || [];
  const summary = {
    total: responseData.total,
    total_active: responseData.total_active || 0,
    total_inactive: responseData.total_active || 0,
    joined_this_month: responseData.joined_this_month || 0,
  };
  const paginationInfo = {
    current_page: responseData.current_page || 1,
    last_page: responseData.last_page || 1,
    per_page: responseData.per_page || 10,
    total: responseData.total || 0,
  };
  // console.log({
  //   Response: apiResponse,
  //   "Response Original": responseData,
  //   "Customer Data Array": customersData,
  // });

  return {
    // Data
    customersData,
    apiResponse,
    summary,
    // Pagination info
    paginationInfo,

    // Pagination handlers
    handlePageChange,
    handlePageSizeChange,

    // Search state and handler
    search,
    handleSearch,

    // Loading states
    isLoading,
    isFetching,

    // Error states
    error,
    isError: !!error,

    // Actions
    refetch,
  };
};
